module.exports = __webpack_public_path__ + "static/img/RYAN-MARIC.6f4a91a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RYAN-MARIC.jpg
// module id = lzlt
// module chunks = 0